import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ApplicationResponse, StateTrackedData} from "@common/domain/common.model";
import {ProductsDataModel} from "@views/master-data/domain/products.model";
import api from "@common/services/api.service";


export const fetchProducts = createAsyncThunk<ProductsDataModel[], void>(
    "product/fetchProducts",
    async () => {
        const response = await api.get<ApplicationResponse<ProductsDataModel[]>>("product")
        console.log("products", response)
        return response.data.data as ProductsDataModel[]
    }
)


const productsSlice = createSlice({
    name: 'product',
    initialState: {
        status: "loading",
        data: [],
        error: null
    } as StateTrackedData<ProductsDataModel[]>,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchProducts.pending, (state) => {
                state.status = "loading"
                state.error =null
                state.data = []
            }
        ).addCase(fetchProducts.fulfilled, (state, action) => {
            state.status = "idle"
            state.data = action.payload
            state.error = null
        }).addCase(fetchProducts.rejected, (state, action) => {
            state.status = "failed"
            state.error = action.error.message
            state.data = []
        })
    }
})
export default productsSlice.reducer;